import React from "react";
import { Link } from "react-router-dom";
import Button from "@mui/material/Button";
import AddIcon from "@mui/icons-material/Add";

const Block = ({ link = "#", blockId, setBlockId, blockName, activeTab }) => {
  const isActive = blockId === activeTab;

  return (
    <div className="documentation-block-item">
      <Link to={link} style={{ textDecoration: "none", display: "block" }}>
        <Button
          type="button"
          disableElevation
          className={`block-button${isActive ? " active" : ""}`}
          onClick={() => setBlockId && setBlockId(blockId)}
        >
          <span className="block-name">{blockName}</span>
          {isActive && <span className="block-active-dot" />}
        </Button>
      </Link>
    </div>
  );
};

const NewBlockButton = ({ onClick }) => {
  return (
    <div className="documentation-block-item">
      <Button
        type="button"
        className="new-block-button"
        onClick={onClick}
        startIcon={<AddIcon />}
      >
        New Tab
      </Button>
    </div>
  );
};

export { Block, NewBlockButton };
